







import { Component, Vue, Provide, Prop} from 'vue-property-decorator';
@Component({
    components: {
    },
})
export default class extends Vue {
    @Prop() title!: string;
    @Prop() type!: string;
    private titles:string='';
    private back() {
        if (this.type == 'game') {
            this.$router.push(
            {
                path: '/vocabulary/afterschoolexpand',
                query: {
                    type: 'through'
                    }
            }
        )
        } else {
            this.$router.go(-1);
        }

    }
    private created(){
        if(this.title){
            this.titles = this.title;
        }else {
            this.titles = <string>window.LS.get('basicData').courseName
        }
    }
}
